var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatmapLayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1052.2 824.2",
    style: {
      enableBackground: "new 0 0 1052.2 824.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2.0043;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#000000;stroke-width:1.2379;stroke-linejoin:round;}\n\t.st2{fill:#D4D2D1;stroke:#000000;stroke-width:1.3362;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-width:1.2379;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:1.2379;stroke-linejoin:round;}\n\t.st5{fill:none;stroke:#000000;stroke-width:1.2379;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:1.3362;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M929.4,707c-0.7-5.8-1.4-11.5-2.1-17.3c-0.4-3.1-2-6-4.5-8l-5.4-4.3c-0.9-13.5-0.9-27.1-2.6-40.5 c-1.2-9.6-3.4-19-5.3-28.4c-0.6-3-2.2-5.7-4.4-7.7c0.2,0.3,0.2,0.3,0,0c-0.9-0.9-2-1.6-3.2-2.2l-15.7-7.9l-28.7-36.8 c-1.4-3.6-2.8-7.3-4.2-10.9c-1.2-2.8-2.3-5.7-3.5-8.5c-28.2-2.6-57-4.9-86.2-7.1c-27.9-2-55.5-3.8-82.6-5.2c0,0-78.3-4.1-154.8,1 c-11.8,0.8-21.2,2-24.4,2.4c-18.6,2.5-33.9,6.1-44.8,9.1c1.4,2.8,2.8,5.6,4.2,8.5c-23.2,9.3-48.6,21-75.2,35.7 c-20.2,11.1-38.6,22.5-55,33.7c-10.5,0.2-20.9,0.3-31.4,0.5c0,0,0,0,0,0s0,0,0,0c-9.8,0.2-19.7,0.3-29.5,0.5 c-24.5,3.4-51.7,8.6-80.7,16.3c-22.2,5.9-42.7,12.5-61.2,19.4c2,13.9,2.7,25.4,2.9,33.7c0.1,4.6,0.2,9.1-2.7,13.4 c-4.1,6.3-11.7,8-15,8.5c-1.3,22.4,3.1,40.7,6.5,51.8c27,4.4,54,8.8,81.1,13.2c-6.8-30.2,3.7-61.2,26.9-79.6 c19.6-15.6,46.1-20.4,68.9-13.2c34.2,10.8,58,48,54.7,90.3c114.1-1.5,228.2-2.9,342.4-4.4c-6.3-45.1,26.4-85.7,67.9-89.9 c43.5-4.4,84.9,32.3,84.5,80.1c22.5-1.3,44.9-2.6,67.4-3.9c3-4.3,6.2-9.7,9.1-16.3c3.4-7.8,5.4-15,6.5-21 C929.6,710.3,929.6,708.6,929.4,707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.5,696.2c2.9-4.3,2.8-8.9,2.7-13.4c-0.3-8.3-1-19.8-2.9-33.7c-4.9,9.8-10.2,23.2-13,39.9 c-0.9,5.4-1.5,10.7-1.8,15.8C116.8,704.2,124.4,702.5,128.5,696.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M386.1,578.8c26.6-14.6,52-26.3,75.2-35.7c-1.4-2.8-2.8-5.6-4.2-8.5c-25.5,9.3-53.5,21-83,35.8 c-27.8,13.9-52.6,28.5-74.3,42.5c10.5-0.2,20.9-0.3,31.4-0.5C347.6,601.3,365.9,589.9,386.1,578.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M886.2,590.7l15.7,7.9c1.2,0.6,2.2,1.3,3.2,2.2c-3.9-6-8.2-12.3-12.8-18.7c-3.2-4.5-8.4-11.6-14.9-19.4 c-6.3-7.6-15.3-17.5-27.1-28.2c2.4,6.5,4.9,13,7.3,19.4L886.2,590.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.4,625.2L764.1,594c9.4-0.7,18.3-4.7,25-11.4l20-20c3.8-3.8,1.7-10.4-3.7-11.2 c-56.2-9-104.4-13.1-141.5-15c-137.6-7.2-186.7,11.8-199.7,17.3c-11.9,4.9-35.7,15.9-61.9,30C373.2,599.2,349.8,614.1,333.4,625.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M557.5,541.7c-32.9,2.1-66.9,6.9-91.1,17c-12.3,5.1-35.7,15.9-61.4,29.7c-17.2,9.3-34.2,19.2-50.8,29.7 l191.3-13.8C549,586.4,554.6,557.2,557.5,541.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M805.6,557.5c-0.1-0.4-0.4-0.7-0.9-0.7c-31.6-5-63.4-9-95.2-11.7l24,45.7l30.3-2.2c8.1-0.6,15.8-4.1,21.5-9.8 l20-20C805.6,558.3,805.7,557.9,805.6,557.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M693.8,543.7c-10-0.8-20-1.4-30-1.9c-20.2-1.1-39.6-1.6-57.6-1.6c-7,0-14.4,0.1-22,0.3l-1.7,61.1l131.9-9.5 L693.8,543.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.8,611.9l10,6.7c-4.1,3.3-8.1,6.6-12.2,9.9c-0.3,0.1-3.1,0.6-5.4-1.5c-1.9-1.7-1.9-4-2-4.4L386.8,611.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M411.9,597.6c-2.7-0.4-5.8-0.3-8.5-0.3c-7.3,0.2-15.2,0.4-18.2,5c-2.3,3.6-0.6,8.1,1.5,10.8 c4.3,5.4,13.7,7.1,20.3,4.8C408.4,611,410,604.3,411.9,597.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M570.2,535.5l-6.3,73c-1.4,5.2-3.2,12.8-4.9,22.1c0,0-2.8,15.9-3.9,34.7c-2.2,37.7,2.5,80.2,2.8,82.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369,622.6c-1.2,3.5-2.8,8.6-4.4,14.8c-3,12.1-5.6,28.7-3.9,59.1c0.8,14.3,2.6,32.7,6.8,54.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.5,639.2c12.3-2.4,25.1-4.6,38.4-6.5c34.1-4.9,66.1-7.1,95.4-7.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.2,639.5c-0.2,0-0.4,0-0.6,0c-9.4,1.4-20.8,3.9-33.3,8.3c-11.5,4.1-21.2,8.9-29.1,13.5 c-1.5,0.9-0.9,3.2,0.9,3.2c7.5-0.2,15.4-0.6,23.5-1.4c27-2.5,51-7.7,71.5-13.9c1.7-0.5,1.6-2.9-0.2-3.3 C224,643.8,213.1,641.7,202.2,639.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M886.9,631.5c7.1,14.4,13.1,28.6,18.2,42.1c4.1,1.2,8.2,2.5,12.3,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M820.8,532.1c5.7,6.5,11.3,13.3,16.9,20.5c13.5,17.4,25.1,34.9,35,52.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.8,717.9l26.4-6.2c4.3-1,8.6,1.5,9.9,5.8l2,6.6c1.6,5.2-2,10.6-7.3,11l-27.5,2.3c-3.8,0.3-7.4-2-8.6-5.7 c-0.3-0.9-0.6-1.7-0.9-2.6c0,0,0-0.1,0-0.1C130.1,724.2,132.9,719,137.8,717.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.5,723.1c0-4.7-1.6-8.4-3.6-8.4c-2,0-3.6,3.8-3.6,8.4c0,4.7,1.6,8.4,3.6,8.4 C167.8,731.5,169.5,727.8,169.5,723.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 705.9,
    y1: 539.1,
    x2: 709.5,
    y2: 545
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.9,750.7c106.5-1.5,213-3.1,319.5-4.6c1.8-40,31.1-73.3,69.5-79.9c35.8-6.1,72.2,12.3,89,45.6 c28.1-2.5,56.1-5,84.2-7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.1,750.1l74.1-3.2c0.1-5.9,0.9-37.7,26.3-61c19.5-17.8,42.1-20.2,49.9-20.9c5.8-0.5,29.6-2.1,53.4,12 c39.1,23.1,44.5,68.2,45,73.6h-15.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540,643.7c0-1.8-8.9-3.2-19.7-3c-10.9,0.2-19.7,1.8-19.6,3.7c0,1.8,8.9,3.2,19.7,3 C531.2,647.2,540,645.5,540,643.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M743.3,630.6c0-1.8-8.9-3.2-19.7-3c-10.9,0.2-19.7,1.8-19.6,3.7c0,1.8,8.9,3.2,19.7,3 C734.5,634,743.3,632.4,743.3,630.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 147.5,
    y1: 656.9,
    x2: 128.3,
    y2: 649.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.4,756.1c0,34-28.2,61.6-63.1,61.6c-34.8,0-63.1-27.6-63.1-61.6c0-34,28.2-61.6,63.1-61.6 C308.1,694.6,336.4,722.1,336.4,756.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321.2,756.1c0,25.8-21.4,46.7-47.9,46.7s-47.9-20.9-47.9-46.7c0-25.8,21.4-46.7,47.9-46.7 C299.7,709.4,321.2,730.3,321.2,756.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 769,
    cy: 756.1,
    rx: 63.1,
    ry: 61.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 769,
    cy: 756.1,
    rx: 47.9,
    ry: 46.7
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M733.5,590.7l3.6,5.3c2.4,3.2,5.6,8.2,7.9,14.9c1.7,5.1,3,11.1,2.6,27c-0.2,8-0.8,18.5-2.4,30.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 187.3,
    y1: 660.2,
    x2: 219,
    y2: 685.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M855.9,622l50.3,15.4c1-4.6,1.9-10.4,2-17.2c0.1-5.3-0.4-10.2-1-14.4l-69.1-2.3c-2.5-0.1-3.9,3-2.1,4.8 l4.3,4.3C844.7,617,850.1,620.2,855.9,622z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.9,560.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M886.4,559.4c1.7,2.4,3.8,5,6.4,7.5c4.6,4.7,9.3,8,13.4,10.5c1.3,0.8,2.7,1.3,4.2,1.6 c3.8,0.8,7.9,1.5,12.2,2.1c5.2,0.8,10.1,1.3,14.7,1.6c0.4,0,0.7,0,1.1,0c17.4,0,36.9-1.1,58-3.9c5.2-0.7,10.3-1.5,15.3-2.3 c14.3-2.4,24.7-14.8,24.7-29.3v-135l0-135c0-14.5-10.4-26.9-24.7-29.3c-5-0.8-10.1-1.6-15.3-2.3c-21.1-2.8-40.6-3.9-58-3.9 c-0.4,0-0.7,0-1.1,0c-4.6,0.3-9.6,0.8-14.7,1.6c-4.3,0.6-8.4,1.4-12.2,2.2c-1.5,0.3-2.9,0.9-4.2,1.6c-4.1,2.4-8.7,5.6-13.3,9.8 c-2.8,2.6-5.2,5.1-7.2,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M924.2,534"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1036.9,525.1l-4-4c-13.6-13.6-21.3-32.1-21.3-51.3v-57.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1004.8,521.3l9.5,13.6c1.3,1.9,2.1,4.2,2.1,6.6l0,26c-3.1-3.2-7.5-8.7-10.5-16.6 C1001,537.6,1003.5,525.9,1004.8,521.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M885.8,559.9l9.4-53.6l27.3,15.6c1.6,18.8-7,34.6-19.5,38.7C896.5,562.8,890.1,561.4,885.8,559.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M885.8,264.6l9.4,53.6l27.3-15.6c1.6-18.8-7-34.6-19.5-38.7C896.5,261.7,890.1,263.1,885.8,264.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M924.2,290.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M922.2,290.5c7.1,0,16.7,0.3,24.7,0.9c9.8,0.8,18.8,2,27.1,3.4c0,39.1,0,78.3,0,117.4c0,39.1,0,78.3,0,117.4 c-8.3,1.4-17.3,2.7-27.1,3.4c-8,0.6-17.6,0.9-24.7,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1001.3,246.3l-8.9,38.9c-2.2,9.5-3.3,19.1-3.3,28.8v98.2v98.2c0,9.7,1.1,19.4,3.3,28.8l8.9,38.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "895.2,318.3 895.2,412.3 895.2,506.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1036.9,299.4l-4,4c-13.6,13.6-21.3,32.1-21.3,51.3l0,57.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1004.8,303.2l9.5-13.6c1.3-1.9,2.1-4.2,2.1-6.6v-26c-3.1,3.2-7.5,8.7-10.5,16.6 C1001,286.9,1003.5,298.6,1004.8,303.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.6,411.8c-0.2-21.4,0.6-44.7,2.8-69.7c1.3-14.9,3.1-29,5.1-42.4c0.5-3.2-1.6-6.3-4.7-6.9 c-19.6-3.5-39.9-6.8-60.8-9.7c-18.5-2.6-36.6-4.8-54.2-6.6c-25.6-2.7-49.7,13.1-58.3,38.5c-0.1,0.2-0.1,0.3-0.2,0.5 c-12.7,37.8-14.8,71.9-14.8,96.4v0.4c0,24.5,2.1,58.6,14.8,96.4c0.1,0.2,0.1,0.3,0.2,0.5c8.6,25.3,32.7,41.1,58.3,38.5 c17.6-1.8,35.7-4,54.2-6.6c20.9-2.9,41.2-6.2,60.8-9.7c3.1-0.6,5.2-3.6,4.7-6.9c-2-13.4-3.8-27.6-5.1-42.4c-2.2-25-3-48.3-2.8-69.7 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M832.8,412.9c-0.1-7.1,0.1-18.9-0.3-31.1c-0.6-17.7-1.8-31.2-2.9-44.1c-0.8-8.8-1.9-20.4-3.6-34.3 c7-0.7,18.3-1,31.4,3.1c0.2,0.1,0.3,0.1,0.5,0.2c19.2,6.1,33,23.9,34.9,44.8c0.5,6.1,1,12.3,1.4,18.7c0.9,14.7,1.1,28.6,1,41.6v0.4 c0.1,13-0.1,26.9-1,41.6c-0.4,6.4-0.8,12.6-1.4,18.7c-1.9,20.9-15.7,38.7-34.9,44.8c-0.2,0.1-0.3,0.1-0.5,0.2 c-13.1,4-24.4,3.8-31.4,3.1c1.7-13.8,2.8-25.5,3.6-34.3c1.1-12.9,2.3-26.4,2.9-44.1C832.9,430.1,832.9,420,832.8,412.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M895.2,411.8c0.1-13-0.1-26.9-1-41.6c-0.4-6.4-0.8-12.6-1.4-18.7c-1.9-20.9-15.7-38.7-34.9-44.8 c-0.2-0.1-0.3-0.1-0.5-0.2c-13.1-4-24.4-3.8-31.4-3.1c-76.2,2-169.7,3.9-254.7-0.8c-41.9-2.4-82.7-5.5-122.2-9.4 c-19.6-3.5-46-7.5-66.9-10.5c-18.5-2.6-36.6-4.8-54.2-6.6v0c-6.9-3.7-13.8-7.4-20.6-11c-5,0.5-10.1,1-15.3,1.8 c0,0-11.4,1.5-23.4,3.9c-49,9.6-81.9,23.5-81.9,23.5c-11.2,4.7-26.2,11.8-43.3,22l0.1,0.2c-1.1,1-2.4,2.2-3.6,3.7c0,0,0,0-0.1,0.1 c-2.5,2.9-4.1,6.5-5,10.3c-1.1,4.9-2.2,9.9-2.8,15.3c-3,25.7-3,66.3-3,66.3v-0.4c0,0,0,40.6,3,66.3c0.6,5.3,1.8,10.4,2.8,15.3 c0.8,3.8,2.5,7.4,5,10.3c0,0,0,0,0.1,0.1c1.3,1.5,2.5,2.7,3.6,3.7l-0.1,0.2c17.1,10.3,32.1,17.3,43.3,22c0,0,32.8,13.8,81.9,23.5 c12,2.4,23.4,3.9,23.4,3.9c5.2,0.7,10.3,1.3,15.3,1.8c6.9-3.7,13.8-7.4,20.6-11v0c17.6-1.8,35.7-4,54.2-6.6 c20.9-2.9,47.3-6.9,66.9-10.5c39.5-3.9,80.3-7.1,122.2-9.4c85-4.8,178.5-2.8,254.7-0.8c7,0.7,18.3,1,31.4-3.1 c0.2,0,0.3-0.1,0.5-0.2c19.2-6.1,33-23.9,34.9-44.8c0.5-6.1,1-12.3,1.4-18.7c0.9-14.7,1.1-28.6,1-41.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1,411.6c0,31,0.9,62,2.8,92.9c0.2,3.3,5.1,5.4,8.8,3.7c2.9-1.3,5.8-2.7,8.7-4c1.7-0.8,2.6-2.2,2.6-3.7 c-1.7-29.6-2.6-59.3-2.6-88.9c0-29.6,0.9-59.3,2.6-88.9c0.1-1.5-0.9-2.9-2.6-3.7c-2.9-1.3-5.8-2.7-8.7-4c-3.7-1.7-8.6,0.4-8.8,3.7 C33,349.7,32.1,380.6,32.1,411.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.7,411.8c0,23.5,1.2,51.3,7.4,81.5c0.8,4.1,1.7,8.1,2.7,11.9c1.2,5,6.1,7.1,9.6,4c2.7-2.4,5.5-5.3,8.4-8.8 c0.1-0.1,0.1-0.2,0.2-0.2c8.4-10.4,13.2-24.4,13.6-39.2c0-1.1,0.1-2.2,0.1-3.3c0.3-15.9,0-31.2,0-46c0-14.8,0.3-30.2,0-46 c0-1.1,0-2.2-0.1-3.3c-0.4-14.7-5.1-28.8-13.6-39.2c-0.1-0.1-0.1-0.2-0.2-0.2c-2.9-3.5-5.7-6.4-8.4-8.8c-3.4-3.1-8.3-1-9.6,4 c-0.9,3.9-1.8,7.8-2.7,11.9C75.9,360.6,74.7,388.4,74.7,411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.5,259.7c-0.5,8.6-1.8,22.3-2,25.2c0,0.4-0.1,0.8-0.3,1.1l-14.5,30.3c-1.1,2.4-5.2,2.8-6.6,0.7l-3.2-4.8 c-0.1-0.1-0.1-0.2-0.2-0.3c-1.3-2.8-9.4-21.7,4.4-40.9c4.9-6.8,11-11.5,16.2-14.5C139.2,254.7,142.7,256.6,142.5,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.5,563.8c-0.5-8.6-1.8-22.3-2-25.2c0-0.4-0.1-0.8-0.3-1.1l-14.5-30.3c-1.1-2.4-5.2-2.8-6.6-0.7l-3.2,4.8 c-0.1,0.1-0.1,0.2-0.2,0.3c-1.3,2.8-9.4,21.7,4.4,40.9c4.9,6.8,11,11.5,16.2,14.5C139.2,568.8,142.7,566.9,142.5,563.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.7,309.3l-0.3-0.1c-2.1-0.9-3.6-2.7-3.9-4.6l-4.8-33c-1.2-8,5.6-14.4,12.9-11.3l9.6,4 c4.6,1.9,6.8,7.2,5.4,12.2l-8.4,29.2C65,309.3,59.8,311.1,55.7,309.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.1,284.8c5.2,0,9.7-3.5,10-8.2c0.4-5.1-4.1-9.5-10-9.5c-6,0-10.5,4.4-10,9.5 C51.4,281.3,55.9,284.8,61.1,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.7,514.2l-0.3,0.1c-2.1,0.9-3.6,2.7-3.9,4.6l-4.8,33c-1.2,8,5.6,14.4,12.9,11.3l9.6-4 c4.6-1.9,6.8-7.2,5.4-12.2L66.1,518C65,514.2,59.8,512.4,55.7,514.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.1,538.7c5.2,0,9.7,3.5,10,8.2c0.4,5.1-4.1,9.5-10,9.5c-6,0-10.5-4.4-10-9.5 C51.4,542.2,55.9,538.7,61.1,538.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.2,555.9l-15.9,25.9l-0.8,0.6c-19.4-1-39.7-2.8-60.7-5.4c-7.7-1-15.2-2-22.6-3.2 c-4.3-0.7-7.5-4.4-7.5-8.8l0-43.6c0-2.3,0.4-4.6,1.2-6.8l1.5-4.3c0.5-1.5,0.8-3,0.8-4.5c-0.2-31.3-0.3-62.6-0.5-93.9v-0.2 c0.2-31.3,0.3-62.6,0.5-93.9c0-1.5-0.2-3.1-0.8-4.5l-1.5-4.3c-0.8-2.2-1.2-4.5-1.2-6.8v-43.6c0-4.4,3.2-8.1,7.5-8.8 c7.4-1.1,14.9-2.2,22.6-3.2c21.3-2.7,41.9-4.5,61.6-5.5l0,0.1l15.9,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.3,505.3c1.9-6.6,3.9-15.2,5.2-25.4c0.8-6.2,1.4-13.4,1.6-41.5c0-7.4,0.1-16.3,0-26.5 c0.1-10.2,0-19.4,0-26.8c-0.2-28.1-0.8-35.3-1.6-41.5c-1.3-10.2-3.4-18.8-5.2-25.4"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 685.5,
    y1: 746.2,
    x2: 692.5,
    y2: 746.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M929.4,117.5c-0.7,5.8-1.4,11.5-2.1,17.3c-0.4,3.1-2,6-4.5,8l-5.4,4.3c-0.9,13.5-0.9,27.1-2.6,40.5 c-1.2,9.6-3.4,19-5.3,28.4c-0.6,3-2.2,5.7-4.4,7.7c0.2-0.3,0.2-0.3,0,0c-0.9,0.9-2,1.6-3.2,2.2l-15.7,7.9l-28.7,36.8 c-1.4,3.6-2.8,7.3-4.2,10.9c-1.2,2.8-2.3,5.7-3.5,8.5c-28.2,2.6-57,4.9-86.2,7.1c-27.9,2-55.5,3.8-82.6,5.2c0,0-78.3,4.1-154.8-1 c-11.8-0.8-21.2-2-24.4-2.4c-18.6-2.5-33.9-6.1-44.8-9.1c1.4-2.8,2.8-5.6,4.2-8.5c-23.2-9.3-48.6-21-75.2-35.7 c-20.2-11.1-38.6-22.5-55-33.7c-10.5-0.2-20.9-0.3-31.4-0.5c0,0,0,0,0,0s0,0,0,0c-9.8-0.2-19.7-0.3-29.5-0.5 c-24.5-3.4-51.7-8.6-80.7-16.3c-22.2-5.9-42.7-12.5-61.2-19.4c2-13.9,2.7-25.4,2.9-33.7c0.1-4.6,0.2-9.1-2.7-13.4 c-4.1-6.3-11.7-8-15-8.5c-1.3-22.4,3.1-40.7,6.5-51.8c27-4.4,54-8.8,81.1-13.2c-6.8,30.2,3.7,61.2,26.9,79.6 c19.6,15.6,46.1,20.4,68.9,13.2c34.2-10.8,58-48,54.7-90.3c114.1,1.5,228.2,2.9,342.4,4.4c-6.3,45.1,26.4,85.7,67.9,89.9 c43.5,4.4,84.9-32.3,84.5-80.1c22.5,1.3,44.9,2.6,67.4,3.9c3,4.3,6.2,9.7,9.1,16.3c3.4,7.8,5.4,15,6.5,21 C929.6,114.2,929.6,115.9,929.4,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.5,128.3c2.9,4.3,2.8,8.9,2.7,13.4c-0.3,8.3-1,19.8-2.9,33.7c-4.9-9.8-10.2-23.2-13-39.9 c-0.9-5.4-1.5-10.7-1.8-15.8C116.8,120.3,124.4,122,128.5,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M386.1,245.7c26.6,14.6,52,26.3,75.2,35.7c-1.4,2.8-2.8,5.6-4.2,8.5c-25.5-9.3-53.5-21-83-35.8 c-27.8-13.9-52.6-28.5-74.3-42.5c10.5,0.2,20.9,0.3,31.4,0.5C347.6,223.2,365.9,234.6,386.1,245.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M886.2,233.8l15.7-7.9c1.2-0.6,2.2-1.3,3.2-2.2c-3.9,6-8.2,12.3-12.8,18.7c-3.2,4.5-8.4,11.6-14.9,19.4 c-6.3,7.6-15.3,17.5-27.1,28.2c2.4-6.5,4.9-13,7.3-19.4L886.2,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.4,199.3l430.8,31.2c9.4,0.7,18.3,4.7,25,11.4l20,20c3.8,3.8,1.7,10.4-3.7,11.2 c-56.2,9-104.4,13.1-141.5,15c-137.6,7.2-186.7-11.8-199.7-17.3c-11.9-4.9-35.7-15.9-61.9-30C373.2,225.3,349.8,210.4,333.4,199.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M557.5,282.8c-32.9-2.1-66.9-6.9-91.1-17c-12.3-5.1-35.7-15.9-61.4-29.7c-17.2-9.3-34.2-19.2-50.8-29.7 l191.3,13.8C549,238.1,554.6,267.3,557.5,282.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M805.6,267c-0.1,0.4-0.4,0.7-0.9,0.7c-31.6,5-63.4,9-95.2,11.7l24-45.7l30.3,2.2c8.1,0.6,15.8,4.1,21.5,9.8 l20,20C805.6,266.2,805.7,266.6,805.6,267z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M693.8,280.8c-10,0.8-20,1.4-30,1.9c-20.2,1.1-39.6,1.6-57.6,1.6c-7,0-14.4-0.1-22-0.3l-1.7-61.1l131.9,9.5 L693.8,280.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.8,212.6l10-6.7c-4.1-3.3-8.1-6.6-12.2-9.9c-0.3-0.1-3.1-0.6-5.4,1.5c-1.9,1.7-1.9,4-2,4.4L386.8,212.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M411.9,226.9c-2.7,0.4-5.8,0.3-8.5,0.3c-7.3-0.2-15.2-0.4-18.2-5c-2.3-3.6-0.6-8.1,1.5-10.8 c4.3-5.4,13.7-7.1,20.3-4.8C408.4,213.4,410,220.2,411.9,226.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M570.2,289l-6.3-73c-1.4-5.2-3.2-12.8-4.9-22.1c0,0-2.8-15.9-3.9-34.7c-2.2-37.7,2.5-80.2,2.8-82.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369,201.9c-1.2-3.5-2.8-8.6-4.4-14.8c-3-12.1-5.6-28.7-3.9-59.1c0.8-14.3,2.6-32.7,6.8-54.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.5,185.3c12.3,2.4,25.1,4.6,38.4,6.5c34.1,4.9,66.1,7.1,95.4,7.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.2,185c-0.2,0-0.4,0-0.6,0c-9.4-1.4-20.8-3.9-33.3-8.3c-11.5-4.1-21.2-8.9-29.1-13.5 c-1.5-0.9-0.9-3.2,0.9-3.2c7.5,0.2,15.4,0.6,23.5,1.4c27,2.5,51,7.7,71.5,13.9c1.7,0.5,1.6,2.9-0.2,3.3 C224,180.7,213.1,182.8,202.2,185z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M886.9,193c7.1-14.4,13.1-28.6,18.2-42.1c4.1-1.2,8.2-2.5,12.3-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M820.8,292.4c5.7-6.5,11.3-13.3,16.9-20.5c13.5-17.4,25.1-34.9,35-52.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.8,106.6l26.4,6.2c4.3,1,8.6-1.5,9.9-5.8l2-6.6c1.6-5.2-2-10.6-7.3-11l-27.5-2.3c-3.8-0.3-7.4,2-8.6,5.7 c-0.3,0.9-0.6,1.7-0.9,2.6c0,0,0,0.1,0,0.1C130.1,100.3,132.9,105.5,137.8,106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.5,101.4c0,4.7-1.6,8.4-3.6,8.4c-2,0-3.6-3.8-3.6-8.4c0-4.7,1.6-8.4,3.6-8.4 C167.8,93,169.5,96.7,169.5,101.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 705.9,
    y1: 285.4,
    x2: 709.5,
    y2: 279.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.9,73.8c106.5,1.5,213,3.1,319.5,4.6c1.8,40,31.1,73.3,69.5,79.9c35.8,6.1,72.2-12.3,89-45.6 c28.1,2.5,56.1,5,84.2,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.1,74.4l74.1,3.2c0.1,5.9,0.9,37.7,26.3,61c19.5,17.8,42.1,20.2,49.9,20.9c5.8,0.5,29.6,2.1,53.4-12 c39.1-23.1,44.5-68.2,45-73.6h-15.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540,180.8c0,1.8-8.9,3.2-19.7,3c-10.9-0.2-19.7-1.8-19.6-3.7c0-1.8,8.9-3.2,19.7-3 C531.2,177.3,540,179,540,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M743.3,193.9c0,1.8-8.9,3.2-19.7,3c-10.9-0.2-19.7-1.8-19.6-3.7c0-1.8,8.9-3.2,19.7-3 C734.5,190.4,743.3,192.1,743.3,193.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 147.5,
    y1: 167.6,
    x2: 128.3,
    y2: 175.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.4,68.4c0-34-28.2-61.6-63.1-61.6c-34.8,0-63.1,27.6-63.1,61.6c0,34,28.2,61.6,63.1,61.6 C308.1,129.9,336.4,102.4,336.4,68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321.2,68.4c0-25.8-21.4-46.7-47.9-46.7c-26.5,0-47.9,20.9-47.9,46.7c0,25.8,21.4,46.7,47.9,46.7 C299.7,115.1,321.2,94.2,321.2,68.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 769,
    cy: 68.4,
    rx: 63.1,
    ry: 61.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 769,
    cy: 68.4,
    rx: 47.9,
    ry: 46.7
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M733.5,233.8l3.6-5.3c2.4-3.2,5.6-8.2,7.9-14.9c1.7-5.1,3-11.1,2.6-27c-0.2-8-0.8-18.5-2.4-30.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 187.3,
    y1: 164.3,
    x2: 219,
    y2: 138.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M855.9,202.5l50.3-15.4c1,4.6,1.9,10.4,2,17.2c0.1,5.3-0.4,10.2-1,14.4l-69.1,2.3c-2.5,0.1-3.9-3-2.1-4.8 l4.3-4.3C844.7,207.5,850.1,204.3,855.9,202.5z"
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -79.9565 41.4783)",
    style: {
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 12
    }
  }, "Lorem ipsum"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapLayout);
export default __webpack_public_path__ + "static/media/heatmap-layout.377466f43898fab21b1e3a8539c7660e.svg";
export { ForwardRef as ReactComponent };